// Export all custom React icons here
// Example usage:
// export { default as CustomIcon } from './custom-icon'
// export { default as BrandIcon } from './brand-icon'

// This file allows for clean imports like:
// import { CustomIcon, BrandIcon } from '@/components/icons/react'

export { default as UpArrowIcon } from './UpArrowIcon'
export { default as UpArrowIcon2 } from './UpArrowIcon2'
export { default as DownArrowIcon } from './DownArrowIcon'
export { default as DoubleChevronLeftIcon } from './DoubleChevronLeftIcon'
export { default as DoubleChevronRightIcon } from './DoubleChevronRightIcon'
export { default as GridIcon } from './GridIcon'
export { default as MenuIcon } from './MenuIcon'
export { default as CheckCircleIcon } from './CheckCircleIcon'
export { default as SparkleIcon } from './SparkleIcon'
export { default as WavesDecorativeIcon } from './WavesDecorativeIcon'
export { default as CurveDecorativeIcon } from './CurveDecorativeIcon'
export { default as ColorEditIcon } from './ColorEditIcon'
export { default as CodeIcon } from './CodeIcon'
export { default as BookIcon } from './BookIcon'
export { default as CalendarIcon } from './CalendarIcon'
export { default as ChartBarsIcon } from './ChartBarsIcon'
export { default as FilterIcon } from './FilterIcon'
export { default as TranscriptIcon } from './TranscriptIcon'
export { default as AiBadgeIcon } from './AiBadgeIcon'
export { default as MonitorIcon } from './MonitorIcon'
export { default as DocumentIcon } from './DocumentIcon'
export { default as NewsCardIcon } from './NewsCardIcon'
export { default as CalendarOutlineIcon } from './CalendarOutlineIcon'
export { default as BriefcaseIcon } from './BriefcaseIcon'
export { default as FileIcon } from './FileIcon'
export { default as MagicFileIcon } from './MagicFileIcon'
export { default as CopyIcon } from './CopyIcon'
